import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { setOnUpdateCallback } from "../serviceWorker";

const UpdateAppPrompt = () => {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(
    null
  );
  const [isUpdating, setIsUpdating] = useState(false);

  const onSWUpdate = useCallback((registration: ServiceWorkerRegistration) => {
    if (!isUpdating) {
      setShowReload(true);
      setWaitingWorker(registration.waiting);
    }
  }, [isUpdating]);

  const reloadPage = () => {
    setIsUpdating(true);
    setShowReload(false);
    waitingWorker?.postMessage({ type: "SKIP_WAITING" });
    window.location.reload();
  };

  useEffect(() => {
    setOnUpdateCallback(onSWUpdate);
  }, [onSWUpdate]);

  return (
    <Modal isOpen={showReload} centered style={{ zIndex: 2000 }}>
      <ModalHeader>An app update is available!</ModalHeader>
      <ModalBody>
        <Row>
          <Col className="text-center">
            <Button
              className="run-number-btn"
              color="primary"
              onClick={reloadPage}
            >
              Update Now
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default UpdateAppPrompt;
